import React from 'react';
import PaginationContainer from './PaginationContainer';
import ProductList from './ProductList';
import PropTypes from 'prop-types';
import MoreButton from '../../components/MoreButton';
import MobileSelectedFacets from '../Facets/MobileSelectedFacets';
import CheckboxFacets from './../CheckboxFacets';

const ProductSearchResultsContainer = ({ attributes,
    onAttributeChange,
    onClearAttributes,
    paginationViewModel,
    onCurrentItemsPerPageChange,
    onCurrentSortByChange,
    products,
    recommendedProducts,
    onResultClick,
    onShowMobileFacetsChange,
    categoryName,
    categoryImageUrl,
    categoryImageAltText,
    categoryDescription,
    translationUtility,
    promotionalArea,
    addToCart,
}) => {
    const perMoreAmount = 12;
    const nextRequest = Math.min(paginationViewModel.CurrentItemsOnPage + perMoreAmount, paginationViewModel.ResultsTotal);
    const showMore = paginationViewModel.ResultsTotal > paginationViewModel.CurrentItemsOnPage;
    const categoryDescriptionHtml = {
        __html: categoryDescription
    };
    const promotionalAreaHtml = {
        __html: promotionalArea
    };
    return (
        <div>
            <div className="row">
                <div className="facets-wrapper col-md-3">
                    <CheckboxFacets 
                        attributes={attributes}
                        onAttributeChange={onAttributeChange}
                        translationUtility={translationUtility}
                    />
                    {promotionalArea && <div className="promotional-area" dangerouslySetInnerHTML={promotionalAreaHtml}></div>}
                </div>
                <div className="product-list-wrapper col-md-9 col-sm-12">
                    {categoryName && categoryName.length > 0 &&
                        <div className="row">
                            <div className="col-12 banner-wrapper">
                                <img 
                                    src={categoryImageUrl} 
                                    alt={categoryImageAltText}
                                    className="img-fluid"  
                                />
                                <div className="category-details-wrapper">
                                    <h1>{categoryName}</h1>
                                    <div className="d-m-block" dangerouslySetInnerHTML={categoryDescriptionHtml}></div>
                                </div>
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-12">
                            <div className="category-list-top-pagination-wrapper">
                                <PaginationContainer
                                    paginationViewModel={paginationViewModel}
                                    onCurrentSortByChange={onCurrentSortByChange}
                                    onShowMobileFacetsChange={onShowMobileFacetsChange}
                                    translationUtility={translationUtility}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row d-md-none">
                        <div className="col-12">
                            <MobileSelectedFacets
                                attributes={attributes}
                                onAttributeChange={onAttributeChange}
                                onClearAttributes={onClearAttributes}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="product-list col-12 js-product-list">
                            <ProductList products={products} onResultClick={onResultClick} addToCart={addToCart} translationUtility={translationUtility}/>
                        </div>
                    </div>
                    {showMore &&
                        <div className="row">
                            <div className="col-12 text-center">
                                <MoreButton
                                    onClick={() => onCurrentItemsPerPageChange(nextRequest)}
                                    text={translationUtility.translateResourceString("/Search/LoadMore")}
                                />
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};

ProductSearchResultsContainer.propType = {
    attributes: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        DisplayName: PropTypes.string,
        Values: PropTypes.arrayOf(PropTypes.shape({
            Name: PropTypes.string,
            Checked: PropTypes.bool,
            Count: PropTypes.number
        }))
    })),
    onAttributeChange: PropTypes.func,
    onClearAttributes: PropTypes.func,
    paginationViewModel: PropTypes.shape({
        ResultsTotal: PropTypes.number,
        CurrentSortBy: PropTypes.string,
        CurrentItemsOnPage: PropTypes.number
    }),
    onCurrentItemsPerPageChange: PropTypes.func,
    onCurrentSortByChange: PropTypes.func,
    products: PropTypes.arrayOf(PropTypes.shape({
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        IsRestricted: PropTypes.bool
    })),
    recommendedProducts: PropTypes.arrayOf(PropTypes.shape({
        RecommendationId: PropTypes.number,
        Name: PropTypes.string,
        Url: PropTypes.string,
        Image: PropTypes.shape({
            Url: PropTypes.string,
            Alt: PropTypes.string
        }),
        Description: PropTypes.string,
        IsRestricted: PropTypes.bool
    })),
    onShowMobileFacetsChange: PropTypes.func.isRequired,
    expandedFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleFacetExpanded: PropTypes.func,
    translationUtility: PropTypes.shape({
        translateResourceString: PropTypes.func
    }),
    showMoreFacets: PropTypes.arrayOf(PropTypes.string),
    onToggleShowMoreFacet: PropTypes.func,
    promotionalArea: PropTypes.string
};

export default ProductSearchResultsContainer;



// WEBPACK FOOTER //
// ./src/Components/search/Features/Products/ProductSearchResultsContainer.jsx